module.exports = __webpack_public_path__ + "img/状态撤回.b7bbf9cd.svg";